module.exports = __webpack_public_path__ + "media/application/images/svgs/award-3e0da38b40add13bf3ca6e39915a3a83.svg";